var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRobotLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_20147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4 17.6172H14.6C12.6118 17.6172 11 19.229 11 21.2172V33.0172C11 35.0054 12.6118 36.6172 14.6 36.6172H33.4C35.3882 36.6172 37 35.0054 37 33.0172V21.2172C37 19.229 35.3882 17.6172 33.4 17.6172Z",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 17.6171V14.2871",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9998 13.9176C32.3529 13.9176 33.4498 12.8207 33.4498 11.4676C33.4498 10.1145 32.3529 9.01758 30.9998 9.01758C29.6467 9.01758 28.5498 10.1145 28.5498 11.4676C28.5498 12.8207 29.6467 13.9176 30.9998 13.9176Z",
    stroke: "#121619",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17.6171V14.2871",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9998 13.9176C18.3529 13.9176 19.4498 12.8207 19.4498 11.4676C19.4498 10.1145 18.3529 9.01758 16.9998 9.01758C15.6467 9.01758 14.5498 10.1145 14.5498 11.4676C14.5498 12.8207 15.6467 13.9176 16.9998 13.9176Z",
    stroke: "#121619",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3446 25.6846C16.8369 25.1682 16.8404 24.3448 17.3421 23.8417C17.8585 23.334 18.682 23.3375 19.185 23.8392C19.6928 24.3556 19.6893 25.179 19.1875 25.6821C18.6712 26.1899 17.8477 26.1863 17.3446 25.6846Z",
    fill: "#121619",
    stroke: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8144 23.8392C29.3174 23.3375 30.1409 23.334 30.6573 23.8417C31.159 24.3448 31.1625 25.1682 30.6548 25.6846C30.1517 26.1863 29.3282 26.1899 28.8119 25.6821C28.3102 25.179 28.3066 24.3556 28.8144 23.8392Z",
    fill: "#121619",
    stroke: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2402 30.6172H27.7602",
    stroke: "#121619",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_20147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRobotLight);
export default __webpack_public_path__ + "static/media/icon_robot_light.effd56da.svg";
export { ForwardRef as ReactComponent };